import React from 'react';
import classNames from 'classnames';

import css from './IconShieldCheck.module.css';

/**
 * Line-art shield with check — Live Arrival Guarantee badge icon.
 *
 * @component
 */
const IconShieldCheck = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path d="M12 3 5 6v5.5c0 4.4 2.9 7.6 7 8.5 4.1-.9 7-4.1 7-8.5V6l-7-3Z" />
      <path d="m9.2 12.2 1.8 1.8 3.8-4" />
    </svg>
  );
};

export default IconShieldCheck;
